import { render } from "./hkkfPage.vue?vue&type=template&id=62edf9c2&scoped=true&ts=true"
import script from "./hkkfPage.vue?vue&type=script&lang=ts"
export * from "./hkkfPage.vue?vue&type=script&lang=ts"

import "./hkkfPage.vue?vue&type=style&index=0&id=62edf9c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62edf9c2"]])

export default __exports__